// src/components/common/AnalyticsPageView.tsx
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { track } from '../../utils/analytics';

/**
 * Component to track page views for analytics
 * This component should be placed once near the router root to track all route changes
 */
export const AnalyticsPageView: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    // Track page view when location changes
    track('$pageview', {
      path: location.pathname,
      title: document.title,
      search: location.search || undefined,
    });
  }, [location.pathname, location.search]);

  // This component doesn't render anything
  return null;
};

export default AnalyticsPageView;
